import { render, staticRenderFns } from "./plrk.vue?vue&type=template&id=8c5f4270&scoped=true&"
import script from "./plrk.vue?vue&type=script&lang=js&"
export * from "./plrk.vue?vue&type=script&lang=js&"
import style0 from "./plrk.vue?vue&type=style&index=0&id=8c5f4270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5f4270",
  null
  
)

export default component.exports